import React from "react";

const SideBarContext = React.createContext({
  sideBarOpen: false,
  closeSidebar: () => {},
  openSidebar: () => {},
});

export default SideBarContext;
